import {Controller} from "@hotwired/stimulus"
import {DirectUpload} from "@rails/activestorage"

const csrfToken = document.getElementsByName("csrf-token")[0].content;
let attachmentfiles = []
export default class MessagePreviewController extends Controller {
    static targets = ["input"]

    connect() {
        this.quill = null;
        this.element.addEventListener("submit", (e) => {
            e.preventDefault()
            this.submitMessageForm(this.element)
        })

        this.element.addEventListener("turbo:submit-start", (e) => {
            $(e.target).find('.chat-footer').addClass('disabled')
        })

        this.element.addEventListener("turbo:submit-end", (e) => {
            $(e.target).find('.chat-footer').removeClass('disabled')
            $(e.target)[0].reset();
            this.resetQuillInput(true) 
            $('#attachment-previews').addClass('d-none')
            $('#audio-record-button').removeClass('disabled')
            $('#msgEmojiPicker').removeClass('disabled')
            $('#msgInputBox').removeClass('disabled')
            $('#messageAttachments').removeClass('disabled')
            $('#attachments_name').empty()
            $('.reply-msg').remove()
        })
    }

    resetQuillInput(focus = false) {
        const quillController = this.application.getControllerForElementAndIdentifier(this.element.querySelector("[data-controller='quill']"), 'quill');

        if (quillController) {
            quillController.clear()
            if (focus) { quillController.quill.focus() }
        }
    }

    selectFile(e, file = false) {
        const input = document.getElementById("message_attachments");
        const newFiles = file ? [file] : Array.from(e.target.files);

        // validate total limit of file attachment
        if (attachmentfiles.length + newFiles.length > 5) {
            $('.show_error').html("You can upload max 5 attachments").addClass('text-danger');
            return;
        }
        $('.show_error').html('');

        // store newly added files into attachment state
        attachmentfiles.push(...newFiles);

        // sync attachment state with actual input field
        const dt = new DataTransfer();
        attachmentfiles.forEach(f => dt.items.add(f));
        input.files = dt.files;

        $('#attachment-previews').removeClass('d-none');

        // display preview of new added files
        newFiles.forEach(file => {
            const reader = new FileReader();
            this.createAndDisplayFilePreviewElements(file, reader);
        });
    }

    createAndDisplayFilePreviewElements(file, reader) {
        reader.onload = () => {
            let element = this.constructPreviews(file, reader);
            element.src = reader.result;
            element.setAttribute("href", reader.result);
            element.dataset.href = reader.result
            element.dataset.target = "_blank"
            element.classList.add("attachment-preview");
            document.getElementById("attachments_name").appendChild(element);
        };
        reader.readAsDataURL(file);
    }

    constructPreviews(file, reader) {
        let element;
        let cancelFunction = (e) => this.removePreview(e);
        switch (file.type) {
            case "image/jpeg":
            case "image/png":
            case "image/webp":
            case "image/gif":
                element = this.createImageElement(cancelFunction, reader);
                break;
            case "video/mp4":
            case "video/quicktime":
                element = this.createVideoElement(cancelFunction, reader);
                break;
            case "audio/mpeg":
            case "audio/mp3":
            case "audio/wav":
            case "audio/ogg":
            case "audio/ogg; codecs=opus":
                element = this.createAudioElement(cancelFunction, reader);
                break;
            case "audio/x-wav":
                element = this.createAudioElement(cancelFunction, reader);
                break;
            default:
                element = this.createDefaultElement(cancelFunction);
        }
        element.dataset.filename = file.name;
        return element;
    }

    createImageElement(cancelFunction, reader) {
        let cancelUploadButton, element;
        const image = document.createElement("img");
        image.style = "background-image: url(" + reader.result + ")"
        image.classList = "bg-cover bg-center"
        image.classList.add("preview-image");
        element = document.createElement("div");
        element.classList.add("attachment-image-container", "file-removal");
        element.appendChild(image);
        cancelUploadButton = document.createElement("i");
        cancelUploadButton.classList.add(
            "ri-close-circle-line",
            "cancel-upload-button",
            "cursor-pointer",
            "position-absolute",
            "top-0",
            "end-0",
            "m-2",
            "text-danger",
            "fw-bolder",
            "fs-18",
            "lh-sm"
        );
        cancelUploadButton.onclick = cancelFunction;
        element.appendChild(cancelUploadButton);
        return element;
    }

    createVideoElement(cancelFunction, reader) {
        let cancelUploadButton, element;
        const video = document.createElement("video");
        video.classList = "bg-cover bg-center"
        video.setAttribute("controls", "controls");
        video.src = reader.result
        video.classList.add("preview-video");
        element = document.createElement("div");
        element.classList.add("attachment-video-container", "file-removal");
        element.appendChild(video);
        cancelUploadButton = document.createElement("i");
        cancelUploadButton.classList.add(
            "ri-close-circle-line",
            "cancel-upload-button",
            "cursor-pointer",
            "position-absolute",
            "top-0",
            "end-0",
            "m-2",
            "text-danger",
            "fw-bolder",
            "fs-18",
            "lh-sm"
        );
        cancelUploadButton.onclick = cancelFunction;
        element.appendChild(cancelUploadButton);
        return element;
    }

    createAudioElement(cancelFunction, reader) {
        let cancelUploadButton, element, element1;

        element = document.createElement("div");
        element1 = document.createElement("div");
        let audio = document.createElement('audio');
        audio.controls = true;
        audio.src = reader.result;
        audio.classList = "bg-cover bg-center";
        element.classList.add("attachment-audio-container", "file-removal");
        element1.appendChild(audio);
        element1.classList.add(
            "d-flex", "justify-content-between", "w-100"
        );
        cancelUploadButton = document.createElement("i");
        cancelUploadButton.classList.add(
            "ri-close-circle-line",
            "cancel-upload-button",
            "cursor-pointer",
            "position-absolute",
            "top-0",
            "end-0",
            "m-2",
            "text-danger",
            "fw-bolder",
            "fs-18",
            "lh-sm"
        );
        cancelUploadButton.onclick = cancelFunction;
        element1.appendChild(cancelUploadButton);
        element.appendChild(element1);
        return element;
    }

    removePreview(event) {
        const target = event.target.closest(".attachment-preview");
        const filename = target.dataset.filename;

        // Remove the selected file from attachment state
        attachmentfiles = attachmentfiles.filter((file) => {
            return file.name !== filename;
        });

        // Rebuild and sync input files after removing attachment
        const attachmentInput = document.getElementById("message_attachments");
        const dt = new DataTransfer();
        attachmentfiles.forEach((file) => {
            dt.items.add(file);
        });

        attachmentInput.files = dt.files;

        target.remove();
        if (attachmentfiles.length === 0) {
            this.toggleVisibility();
        }
        $('#audio-record-button')?.removeClass("disabled")
    }

    submitMessageForm(element) {
        let button = this.element.querySelector('[type="submit"]');
        let loader = this.element.querySelector('#sentLoader')
        button.classList.add('d-none');
        loader.classList.remove('d-none');
        let data = this.serializeForm(element)
        let params = {
            method: 'post',
            headers: {
                "X-CSRF-Token": csrfToken,
                Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
            }
        }
        params['body'] = data
        fetch(element.action, params).then(r => {
            if (r.redirected) {
                globalThis.location.href = r.url
            }
            return r.text()
        }).then(response => {
            if (response.ok) {
                attachmentfiles = []
            }
            element.reset();
            attachmentfiles = []
            let preview = document.getElementById("attachment-previews");
            preview.classList.add("d-none");
            const messages = document.getElementById("chat-history");
            $('#audio-record-button').removeClass('disabled')
            $('#msgEmojiPicker').removeClass('disabled')
            $('#msgInputBox').removeClass('disabled')
            $('#messageAttachments').removeClass('disabled')
            $("[name='message[parent_id]']").remove()
            $('#attachments_name').empty()
            $('.reply-msg').remove()
            this.resetQuillInput(true) 
            Turbo.renderStreamMessage(response)
            button.classList.remove('d-none');
            loader.classList.add('d-none');
            this?.quill?.quill?.setText("")
            setTimeout(() => {
                messages.scrollTop = messages.scrollHeight - messages.clientHeight;
            }, 100);
        })
    }

    serializeForm = function (form) {
        let formData = new FormData(form);
        let files = attachmentfiles
        $.each(files, function (ind, val) {
            formData.append('message[attachments][]', val);
        });
        delete formData.attachments
        return formData;
    };

    toggleVisibility() {
        let preview = document.getElementById("attachment-previews");
        preview.classList.toggle("d-none");
        $('#attachments_name').empty()
    }

    replyMessage(e) {
        e.preventDefault()
        fetch('/messages/' + $(e.target).attr('data-message-id') + '/reply', {
            method: 'GET',
            headers: {
                "X-CSRF-Token": csrfToken,
                'Content-Type': 'application/json'
            }
        }).then(r => r.json())
            .then(response => {
                if (!response?.status) return;
                let preview = document.getElementById("attachment-previews");
                preview.classList.remove("d-none");
                preview.innerHTML += response.html_content
            })
    }

    clearPreviews() {
        let preview = document.getElementById("attachment-previews");
        preview.classList.add("d-none");
        $('#attachments_name').empty()
        $('.reply-msg').remove()
        $('#audio-record-button').removeClass('disabled')
        $('#msgEmojiPicker').removeClass('disabled')
        $('#msgInputBox').removeClass('disabled')
        $('#messageAttachments').removeClass('disabled')
        attachmentfiles = []
        const attachement = document.getElementById("message_attachments")
        if (attachement && attachement.files.length > 0) {
            attachement.value = ""; // resets file selection on clear
        }
    }

    startAudio(){
        this.audio()
        $('#attachment-previews').removeClass('d-none');
        $('#attachment-previews button')[0].classList.add("d-none")
        this.element.classList.add("disabled")
    }

    audio() {
        let record = document.getElementById("audio-record-button");
        let messageAttachments = document.getElementById("message_attachments");
        let recording = false;
        if (navigator.mediaDevices.getUserMedia) {
            const constraints = {audio: true};
            let chunks = [];
            let onSuccess = function (stream) {
                const mediaRecorder = new MediaRecorder(stream);
                startRecord(record, mediaRecorder)
                recording = !recording;
                let stopRecordAudio = document.getElementById("stop-record");
                stopRecordAudio.onclick = function (event) {
                    event.preventDefault();
                    if (recording) {
                        stopRecord(record, mediaRecorder)
                        stream.getAudioTracks()[0].stop();
                    } else {
                        startRecord(record, mediaRecorder)
                    }
                    recording = !recording;
                };
                mediaRecorder.onstop = function (event) {
                    const audioType = "audio/ogg; codecs=opus";
                    const blob = new Blob(chunks, {type: audioType});
                    chunks = [];
                    let file = new File([blob], "audio-message.ogg", {
                        type: audioType,
                        lastModified: Date.now(),
                    });
                    let container = new DataTransfer();
                    container.items.add(file);
                    messageAttachments.files = container.files;
                    messageAttachments.dispatchEvent(new Event("change"));
                    $('#audio-record-button').removeClass('disabled');
                    $('#messageAttachments').removeClass('disabled');
                    $('#msgInputBox').removeClass('disabled');
                    $('#msgEmojiPicker').removeClass('disabled');
                };
                mediaRecorder.ondataavailable = function (e) {
                    chunks.push(e.data);
                };
            };
            let onError = function (err) {
                throwError(err)
            };
            navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
        }
    }

    submitIfValid(event) {
        const length = parseInt(this.inputTarget.dataset.length || "0", 10);

        if (length === 0 && attachmentfiles.length === 0) {
            event.preventDefault();
            return false;
        }
    }

    removeLinkPreview(e) {
        const previewEle = e.target.closest(".preview-link")
        const linkThumb = previewEle.parentElement
        const urlEle = linkThumb.nextElementSibling;
        urlEle.value = ""
        urlEle.nextElementSibling.value = false;
        previewEle.remove()
    }
}

const stopRecord = (record, mediaRecorder) => {
    mediaRecorder.stop();
    record.style.color = "";
    $(record).find("i").removeClass('fas text-primary').addClass('far ri-play-fill')
    record.dataset.action = "click->message-preview#startAudio"
    $('.timer').remove()
    $('#attachment-previews button')[0].classList.remove("d-none");
}

const startRecord = (record, mediaRecorder) => {
    $(record).find("i").addClass('fas text-primary').removeClass('far')
    let htmlContent = `
<div class="timer text-center d-flex align-items-center justify-content-between gap-3">
  <div class="d-flex align-items-center gap-3">
    <div class="d-flex align-items-center gap-1">
      ${[1, 3, 5, 2, 2, 4, 1, 3, 5, 2, 2, 4, 1, 3, 5, 2]
        .map(n => `<div class="audio-bar bg-white animated-bar rounded-5 bar-${n}"></div>`)
        .join('')}
    </div>
    <div>
      <span class="minutes text-white">00</span>
      <span class="text-white">:</span>
      <span class="seconds text-white">00</span>
    </div>
  </div>
  <button id="stop-record" class="btn btn-primary float-end">
    <i class="ri-stop-fill"></i> Stop
  </button>
</div>
`;
    let preview = document.getElementById("attachment-previews");
    preview.classList.remove("d-none");
    preview.innerHTML += htmlContent
    mediaRecorder.start();
    record.dataset.action = ""
    timer()
}

const timer = () => {
    const minutes = document.querySelector('.minutes');
    const seconds = document.querySelector('.seconds');
    let timerTime = 0;

    const incrementTimer = () => {
        timerTime++;

        const numberMinutes = Math.floor(timerTime / 60);
        const numberSeconds = timerTime % 60;

        minutes.innerText = pad(numberMinutes);
        seconds.innerText = pad(numberSeconds);
    }

    const pad = (number) => {
        return (number < 10) ? '0' + number : number;
    }

    setInterval(incrementTimer, 1000)
}

const uploadFile = (file) => {
    const input = document.getElementById("message_attachments");
    const url = input.dataset.directUploadUrl;
    console.log(url)
    const upload = new DirectUpload(file, url);
    upload.create((error, blob) => {
        if (!error) {
            const hiddenField = document.createElement("input");
            hiddenField.dataset.type = "hidden"
            hiddenField.dataset.value = blob.signed_id
            hiddenField.name = input.name;
            let messageForm = document.getElementById("new_message");
            messageForm.appendChild(hiddenField);
        }
    });
};

function throwError(err) {
	let userMessage = '';
	
	switch(err.name) {
		case 'NotAllowedError':
			userMessage = 'You denied microphone access. Please allow microphone access in your browser settings and reload the page.';
			break;
		case 'PermissionDeniedError':
			userMessage = 'Microphone permission was denied. Check your browser permissions.';
			break;
		case 'NotFoundError':
			userMessage = 'No microphone found on your device.';
			break;
		case 'NotReadableError':
			userMessage = 'Your microphone is in use by another application.';
			break;
		case 'AbortError':
			userMessage = 'Could not access the microphone due to a system error.';
			break;
		default:
			userMessage = 'Unable to access microphone. Please check your settings.';
	}
	alert(userMessage, 5000);
	if ($('#attachment-previews').find('.attachment-preview').length === 0) $('#attachment-previews').addClass('d-none');
	$('#audio-record-button').removeClass('disabled')
}
